import { connect } from "react-redux";
import Calendar from "../../Calendar/Calendar";
import { getDateRange } from "../../../utils";
import Reveal from "../Reveal";
import Section from "./Section";

/** The wedding month with the celebration days marked, in an arched, painted card. */
const CalendarSection = ({ events }) => {
  const { fromDate, toDate } = getDateRange(events || []);
  if (!fromDate) return null;

  return (
    <Section className="ut-calendar" label="Wedding calendar" kicker="Mark Your Calendar" title="Save the Date" deco={["shehnai", "petals"]} tone="blush" seed={43}>
      <Reveal effect="zoom" className="ut-calendar__arch" delay={0.1}>
        <div className="ut-calendar__card">
          <Calendar fromDate={fromDate} toDate={toDate} />
        </div>
      </Reveal>
    </Section>
  );
};

const mapStateToProps = (state) => ({
  events: state.inviteDetails.invite?.events,
});

export default connect(mapStateToProps)(CalendarSection);
